"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTotalBet = void 0;
function getTotalBet(gameId, spin, betLineLoader) {
    return __awaiter(this, void 0, void 0, function* () {
        const bet = spin.bet;
        let totalBet = spin.total_bet;
        let lines = spin.lines;
        let level = spin.level;
        if (totalBet === 0 && bet !== 0) {
            if (lines === 0) {
                lines = 1;
            }
            if (level === 0) {
                level = 1;
            }
            const betLine = yield betLineLoader.getBetLine(gameId, spin.lines);
            if (betLine) {
                if (betLine.override === 0) {
                    totalBet = level * lines * betLine.multiplier * bet;
                }
                else {
                    totalBet = level * betLine.override * bet;
                }
            }
        }
        return totalBet;
    });
}
exports.getTotalBet = getTotalBet;
